import { Component, OnInit, ViewChild,Injector } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { Global } from 'src/app/Global';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { ExcelService } from 'src/app/shared/excel.service';
import { BulkUploadService } from 'src/app/shared/bulk-upload.service';
import { AlertService } from 'src/app/common/alert.service';
import { DropdownModule } from 'primeng/dropdown';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.css'],
  // standalone:true,
  // imports:[DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule]
  
})
export class BulkUploadComponent implements OnInit {

  UploadResponseFileUpload: File;
  DataExportList: any;
  isLoadingResults = false;
  formData: FormData = new FormData();
  private alertService: AlertService;

  displayedColumns = ['FileName', 'UploadedBY', 'UploadDate'];

  ClientResponseDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator,{ static: true }) paginator: MatPaginator;
  @ViewChild(MatSort,{ static: true }) sort: MatSort;
  btnValue: any;

  constructor(private _router: Router,public _commonService: CommonService,
    private status: HTTPStatus,public _global: Global,injector: Injector, 
    private error: AppErrorHandler, private _excelService: ExcelService,
    private _bulkupload:BulkUploadService) {this.alertService = injector.get(AlertService); }

  ngOnInit() {
    this.btnValue='Submit';
    this._global.IsBulkLoad=false;
  }

  onfilechange(event) {      
    this.UploadResponseFileUpload = event;
  }
  CancelUploadFile(event)
  { 
    this._commonService.Exit();    
    event.target.value = '';
    this.formData = null;
    this.UploadResponseFileUpload = null;
    
    //this._router.navigate(['admin/view-recovery']);   
  }
  BulkUploadEmployeeRecovery()
  {    
    this.status.setHttpStatus(true);
    let RecoveryID=0;
    this._bulkupload.BulkUploadEmployeeRecovery(RecoveryID).subscribe(data=>{
      if (data.RequestMessage=='Success') {
        if (data.RequestEntityId !== null) {
          this.alertService.notify('success', 'Success!', "File uploaded successfully.");               
          this._router.navigate(['admin/view-recovery']);
        }
      } else {
        alert('No new records are found in uploaded file.');        
      }
    }, (error) => {
      if (error.status === 406) {
        alert('Your session has been expired.');
        this._router.navigate(['/logout']);
      }
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => {   this.status.setHttpStatus(false); });
  }
  GetAllUploadResponseList() {
    this.status.setHttpStatus(true);
    this._bulkupload.GetAllUploadResponseList().subscribe(data => {
      this.ClientResponseDataSource = new MatTableDataSource(data.RequestData);
      this.ClientResponseDataSource.paginator = this.paginator;
      this.ClientResponseDataSource.sort = this.sort;
    }, (error) => {
      if (error.status === 406) {
        alert('Your session has been expired.');
        this._router.navigate(['/logout']);
      }
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => {   this.status.setHttpStatus(false); });
  }

  UploadAttachment(event) { 
   
    this.status.setHttpStatus(true);  
    if (event != null) {
      if (event.target.files.length > 0) {
        const fileList: FileList = event.target.files;
        const file: File = fileList[0];
        const maxLength = 1024 * 1024 * 5;
        const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx') {
          if (event.target.files[0].size > maxLength) {
            alert('Filesize can not be more than 5 mb.');
            return;
          }
          this.formData = new FormData();
          this.formData.append('Filesupload', file, file.name);
          this._bulkupload.UploadClientResponseData(this.formData).subscribe(data => {
            if (data.RequestIsSuccess) {
              if (data.RequestData.length > 0) {
                alert('Summary file to get status of upload and failure reason.');
                event.target.value = '';
                this.formData = null;
                this._global.IsBulkLoad=true;
                this.UploadResponseFileUpload = null;
                this.DataExportList = data.RequestData;
                this.exportAsXLSX(this.DataExportList);
              } else {
              
                alert('File uploaded successfully.');
                event.target.value = '';
                this.formData = null;
                this.UploadResponseFileUpload = null;
                this._global.IsBulkLoad=true;
              }
            } else {
              alert(data.RequestMessage);
            }
          });
        } else {
          alert('Please upload only xls/xlsx file.');
        }
      } else {
        alert('Please upload xls/xlsx file.');
      }
    } else {
      alert('Please upload xls/xlsx file.');
    }
    this.status.setHttpStatus(false);
  }

  exportAsXLSX(data: any): void {
    this._excelService.exportAsExcelFile(data, 'uploadRevision');
  }
}
